var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9327 5.82129C12.3773 3.14338 10.0933 1.10911 7.36803 0.874471C3.66545 0.555877 0.56131 3.46628 0.56131 7.10213C0.56131 7.60154 0.621593 8.08374 0.731379 8.54872H0.709844L0.74859 8.61975C0.946636 9.41193 4.59971 16.0314 6.13887 18.7997C6.43378 19.3293 7.19366 19.3293 7.48858 18.7997C9.02773 16.0314 12.6808 9.41409 12.8789 8.61975L12.9176 8.54872H12.8961C13.0984 7.69411 13.1307 6.77492 12.9327 5.82129ZM6.81265 9.6229C5.34238 9.6229 4.14981 8.43032 4.14981 6.96005C4.14981 5.48978 5.34238 4.29721 6.81265 4.29721C8.28292 4.29721 9.4755 5.48978 9.4755 6.96005C9.4755 8.43032 8.28292 9.6229 6.81265 9.6229Z",
    fill: "#00B8EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.5b7c90271fb25f48b1be0dc7c4a19945.svg";
export { ForwardRef as ReactComponent };